var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroPropertyType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.4924V18.8C3 18.9105 3.08954 19 3.2 19H7.3C7.41046 19 7.5 18.9105 7.5 18.8V14C7.5 13.7239 7.72386 13.5 8 13.5H11C11.2761 13.5 11.5 13.7239 11.5 14V18.8C11.5 18.9105 11.5895 19 11.7 19H15.8C15.9105 19 16 18.9105 16 18.8V14.25V10.4924C16 10.1819 15.8558 9.88907 15.6097 9.69978L10.1097 5.46901C9.75026 5.19251 9.24974 5.19251 8.89029 5.46901L3.39029 9.69978C3.1442 9.88907 3 10.1819 3 10.4924Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H20.8C20.9105 19 21 18.9105 21 18.8V10.4924C21 10.1819 20.8558 9.88907 20.6097 9.69978L15.0787 5.44513C14.7339 5.17995 14.2573 5.168 13.8998 5.41556L11.9888 6.73855",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPropertyType);
export default __webpack_public_path__ + "static/media/hero-property-type.78bd2cc641fd8a0755de679db474066b.svg";
export { ForwardRef as ReactComponent };